import React from 'react';
import PropTypes from 'prop-types';
import { hasValue, localStorage } from 'swipeclock-frontend';
import { FORM_IDS } from 'providers/LoginProvider';
import { NumberField } from '../shared/StyledComponents';
import FreeSoloAutocompleteField from '../FreeSoloAutocompleteField';

export default function SiteId({ loginBag }) {
  const { getError, handleBlur, handleChange, validationRef } = loginBag;

  // Site data from localStorage
  const sitesData = localStorage.getItem('SwipeClock.WebClock3.SiteID');
  const parsedSitesData = hasValue(sitesData) ? JSON.parse(sitesData) : null;
  const filteredSitesData = hasValue(parsedSitesData)
    ? parsedSitesData.sites.filter((site) => hasValue(site.id))
    : null;
  const defaultSiteId = parsedSitesData?.lastSiteUsed
    ? filteredSitesData.findIndex(
        (site) => site.id === parsedSitesData.lastSiteUsed
      )
    : 0;

  return (
    <>
      {hasValue(filteredSitesData) ? (
        <FreeSoloAutocompleteField
          defaultValue={
            filteredSitesData[defaultSiteId > -1 ? defaultSiteId : 0]
          }
          options={filteredSitesData.map((site) => ({
            label: site.name
              ? `Site ${site.id} - ${site.name}`
              : `Site ${site.id}`,
            value: site.id,
          }))}
          id={FORM_IDS.SITEID}
          handleChange={handleChange(FORM_IDS.SITEID)}
          handleBlur={handleBlur(FORM_IDS.SITEID)}
          validationRef={validationRef}
          error={getError(FORM_IDS.SITEID)}
          label="Site ID (optional)"
        />
      ) : (
        <NumberField
          formatType="integer"
          id={FORM_IDS.SITEID}
          label="Site ID (optional)"
          onBlur={handleBlur(FORM_IDS.SITEID)}
          onChange={handleChange(FORM_IDS.SITEID)}
          validationRef={validationRef}
        />
      )}
    </>
  );
}

SiteId.propTypes = {
  loginBag: PropTypes.object.isRequired,
};
